import React, { useLayoutEffect, useState } from "react";
import { Provider } from "react-redux";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import configStore from "../controller/configStore";
import services from "../data/index";
import AboutUs from "./components/about";
import DisclaimerModal from "./components/common/disclaimer";
import Footer from "./components/common/footer";
import Header from "./components/common/header";
import NotFound from "./components/common/NotFound";
import ToastDisplay from "./components/common/toast";
import Home from "./components/home";
import HowTo from "./components/how-to";
import KeyResources from "./components/key-resources";
import LocationResources from "./components/location-resources";
import LocationItem from "./components/location-resources/item";
import Remedies from "./components/remedies";
import RemedyItem from "./components/remedies/item";
import StoryList from "./components/stories";
import StoryItem from "./components/stories/item";
import TrackList from "./components/tracker";

function App() {
  const [show, setShow] = useState(false);

  const onClose = () => {
    localStorage.setItem("disclaimer", "true");
    setShow(false);
  };

  useLayoutEffect(() => {
    setTimeout(()=> setShow(localStorage.getItem("disclaimer") !== "true"), 3000)
  }, []);

  return (
    <Provider store={configStore(services)}>
      <Router>
        <div className="App">
          <div className="content">
          <Header />
          <Switch>
            <Route path="/" exact component={Home} />
            <Route path="/location-resources" exact component={LocationResources} />
            <Route path="/remedies" exact component={Remedies} />
            <Route path="/track" exact component={TrackList} />
            <Route path="/help" exact component={HowTo} />
            <Route path="/key-resources" exact component={KeyResources} />
            <Route path="/remedy/:id" exact component={RemedyItem} />
            <Route path="/location/:name" exact component={LocationItem} />
            <Route path="/stories" exact component={StoryList} />
            <Route path="/story/:id" exact component={StoryItem} />
            <Route path="/about" exact component={AboutUs} />
            <Route path="*" component={NotFound}/>
          </Switch>
          <DisclaimerModal show={show} onClose={onClose} />
          <ToastDisplay />
          </div>
          <Footer/>
        </div>
      </Router>
    </Provider>
  );
}

export default App;
